// import messages from './messages'
const messages = require('./messages-' + process.env.VUE_APP_NAME).default;

let locale = window.location.pathname.split('/')[2];

// 默认语言
let defaultLocale = process.env.VUE_APP_DEFAULT_LANGUAGE ? 'zh' : 'en';

// 如果链接有携带参数
// 检测是否和参数匹配的语言版本
// 重置本地语言版本
if (locale && locale != '/' && messages[locale]) {
    localStorage.setItem(process.env.VUE_APP_NAME + '_locale', locale);
} else {
    localStorage.setItem(process.env.VUE_APP_NAME + '_locale', defaultLocale);
}

export default {
    locale: locale && locale != '/' && messages[locale] ? locale : defaultLocale,
    base: locale && locale != '/' && messages[locale] ? (locale == defaultLocale ? '' : locale) : ''
}